import React from 'react'
import styled from 'styled-components'
import { sc } from 'src/styles'
import { paypalUrl } from 'src/constants'

import { ReactComponent as _PayPalLogo } from './paypal.svg'

type Props = {
  className?: string
}

export default ({ className = '', ...rest }: Props) => {
  return (
    <Container
      href={paypalUrl}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      <PayPalLogo />
    </Container>
  )
}

const Container = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${sc.fontColor};
  border-radius: 4px;
  transition: all 100ms linear;

  &:hover {
    border-bottom: none;
    background-color: #fff;
  }
`

const PayPalLogo = styled(_PayPalLogo)`
  width: 100px;
  height: 40px;
`
